import { ILogger } from '@cian/logger/shared';
import { IHttpApi } from '@cian/http-api/shared/http';

import { createPutReviewModel, IPutReviewRequest, TPutReviewResponse } from '../repositories/reviews/v2/put-review';
import { IPutAnswerRequest, createPutAnswerModel, TPutAnswerResponse } from '../repositories/reviews/v2/put-answer';
import {
  ISetReviewLikeStatusRequest,
  TSetReviewLikeStatusResponse,
  createSetReviewLikeStatusModel,
} from '../repositories/reviews/v1/set-review-like-status';
import {
  createSetAnswerLikeStatusModel,
  ISetAnswerLikeStatusRequest,
  TSetAnswerLikeStatusResponse,
} from '../repositories/reviews/v1/set-answer-like-status';
import { IGetReviewsRequest, TGetReviewsResponse, createGetReviewsModel } from '../repositories/reviews/v1/get-reviews';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getReviews(client: IHttpApi, options: IGetReviewsRequest, logger: ILogger): any {
  return client
    .fetch({
      ...createGetReviewsModel(options),
    })
    .then((response: TGetReviewsResponse) => {
      if (response.statusCode !== 200) {
        const message = `Unable to get realtor reviews with id ${options.entityId}.`;
        const error = response.response.message;

        const meta = {
          realtorId: options.entityId,
        };

        logger.error(`${message} ${error}`, meta);

        /*
        Если API ответило, но мы отзывы доставить как фичу не можем,
        то валим страницу с ошибкой и логгируем кастомное сообщение.
        Позже сюда подъедет деградация (вместо ошибки отдадим заглушку в стор).
      */
        throw new Error(response.response.message);
      }

      return response.response.data;
    })
    .catch(error => {
      const message = `Fail to get reviews for realtor with id ${options.entityId}.`;

      const meta = {
        realtorId: options.entityId,
      };

      logger.error(`${message} ${error}`, meta);

      /*
      Если API не ответило вообще, то валим страницу с ошибкой.
    */
      throw new Error(error);
    });
}

/**
 * Антимат: statusCode = 400 и ответ в формате:
 * {
 *   "errors": [
 *     {
 *       "key": "obsceneWordFound",
 *       "code": "invalid",
 *       "message": "плохоеслово"
 *     },
 *     {
 *       "key": "obsceneWordFound",
 *       "code": "invalid",
 *       "message": "плохоеслово"
 *     }
 *   ],
 *   "message": "checkObsceneLexisFailed"
 * }
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putReview(client: IHttpApi, options: IPutReviewRequest): any {
  return client
    .fetch({
      ...createPutReviewModel(options),
    })
    .then((response: TPutReviewResponse) => {
      if (response.statusCode !== 200) {
        return response.response;
      }

      return response.response.data;
    });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putAnswer(client: IHttpApi, options: IPutAnswerRequest): any {
  return client
    .fetch({
      ...createPutAnswerModel(options),
    })
    .then((response: TPutAnswerResponse) => {
      if (response.statusCode !== 200) {
        return response.response;
      }

      return response.response.data;
    });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function rateReview(client: IHttpApi, options: ISetReviewLikeStatusRequest): any {
  return client
    .fetch({
      ...createSetReviewLikeStatusModel(options),
    })
    .then((response: TSetReviewLikeStatusResponse) => {
      if (response.statusCode !== 200) {
        throw new Error(response.response.message);
      }

      return response.response.status === 'ok';
    });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function rateAnswer(client: IHttpApi, options: ISetAnswerLikeStatusRequest): any {
  return client
    .fetch({
      ...createSetAnswerLikeStatusModel(options),
    })
    .then((response: TSetAnswerLikeStatusResponse) => {
      if (response.statusCode !== 200) {
        throw new Error(response.response.message);
      }

      return response.response.status === 'ok';
    });
}
